import { Handle, Position } from 'reactflow';
import { IconUsers } from '@tabler/icons-react';
import { Box, Typography } from '@mui/material';
import '../../../organizationalcharts/organogram/styles/nodes.css';
import { useOrganogramContext } from './hooks/useOrganogramContext';

export function ViewOnlyNode({ data, id }) {
    const { openModal } = useOrganogramContext();

    return (
        <>
            <Handle
                type="target"
                position={Position.Top}
                className="org-node-handle"
            />
            <Box
                className="org-node-card view-only-card"
                onClick={() =>
                    openModal({
                        id,
                        ...data
                    })
                }
            >
                <Box className="org-node-content">
                    <Typography variant="subtitle1" className="org-node-title">
                        {data.title}
                    </Typography>
                    <Box className="org-node-members-count">
                        <IconUsers size={12} />
                        <Typography variant="caption">
                            {data.members.length}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Handle
                type="source"
                position={Position.Bottom}
                className="org-node-handle"
            />
        </>
    );
}
